module.exports = __webpack_public_path__ + "static/media/9.ef3ac748.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/slides/9.jpg
// module id = 786
// module chunks = 0